import { __awaiter } from "tslib";
import API from "@ova-studio/api-helper";
export default class Auth {
    static login(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield API.post('auth', data);
            return response.data;
        });
    }
    static getAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield API.getData('auth');
        });
    }
    static logout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield API.delete('auth', {});
        });
    }
}
//# sourceMappingURL=Auth.js.map